import React, { useState } from "react";
import { AITutorDualModePanel, type AITutorDualMode } from "./AITutorDualModePanel";
import type { TelegramUser } from "../types";
import type { QueryMetrics } from "../types/chat";

interface AITutorEditorPanelProps {
  user: TelegramUser | null;
  taskId: string | number;
  taskTitle?: string;
  userCode: string;
  onClose: () => void;
  embedded?: boolean;
  queryMetrics?: QueryMetrics;
  onMinWidthChange?: (width: number) => void;
  onboardingPageKey?: string;
  onboardingCompletedPages?: string[];
  /** Пока грузится статус онбординга с API — см. ChatCore */
  onboardingStatusLoading?: boolean;
  onStartOnboarding?: () => void;
  asideMode?: AITutorDualMode;
  onAsideModeChange?: (mode: AITutorDualMode) => void;
}

export const AITutorEditorPanel = ({
  user,
  taskId,
  taskTitle,
  userCode,
  onClose,
  embedded = false,
  queryMetrics,
  onMinWidthChange,
  onboardingPageKey,
  onboardingCompletedPages,
  onboardingStatusLoading,
  onStartOnboarding,
  asideMode: asideModeProp,
  onAsideModeChange: onAsideModeChangeProp,
}: AITutorEditorPanelProps) => {
  const [internalMode, setInternalMode] = useState<AITutorDualMode>("chat");
  const asideMode = asideModeProp ?? internalMode;
  const onAsideModeChange = onAsideModeChangeProp ?? setInternalMode;

  const containerClass = embedded
    ? "bg-white border border-neutral-border rounded-xl shadow-sm flex flex-col h-full min-h-0 overflow-hidden"
    : "h-full min-h-0 flex flex-col overflow-hidden";

  const chatProps = {
    contextType: "editor" as const,
    taskId,
    taskTitle,
    userCode,
    queryMetrics,
    containerClassName: containerClass,
    headerSubtitle: embedded ? "Спроси меня" : undefined,
    showChatHistoryInEmbedded: embedded,
    onboardingPageKey,
    onboardingCompletedPages,
    onboardingStatusLoading,
    onStartOnboarding,
    enableFeedback: true,
    embedded,
    onMinWidthChange,
  };

  return (
    <AITutorDualModePanel
      user={user}
      onClose={onClose}
      embedded={embedded}
      onMinWidthChange={onMinWidthChange}
      mode={asideMode}
      onModeChange={onAsideModeChange}
      chatProps={chatProps}
    />
  );
};
